const divPhotoUp = {
  load: 'Loading...'
};

export default divPhotoUp;
